var _rect, _circle, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _circle2, _circle3, _circle4, _polygon9, _polygon10, _circle5, _circle6, _circle7, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTalk3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "#1c1530"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 50,
    stroke: "#c09840",
    strokeWidth: 0.8,
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80,8  83,30 77,30",
    fill: "#c09840",
    opacity: 0.8
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,112 77,90 83,90",
    fill: "#c09840",
    opacity: 0.8
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "28,60 50,57 50,63",
    fill: "#c09840",
    opacity: 0.8
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "132,60 110,63 110,57",
    fill: "#c09840",
    opacity: 0.8
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "116,16 103,34 97,28",
    fill: "#c09840",
    opacity: 0.7
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "44,16  57,34 63,28",
    fill: "#c09840",
    opacity: 0.7
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "116,104 97,92 103,86",
    fill: "#c09840",
    opacity: 0.7
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "44,104  63,86 57,92",
    fill: "#c09840",
    opacity: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 28,
    stroke: "#5ab4ac",
    strokeWidth: 1,
    opacity: 0.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 20,
    fill: "#2a1840"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 18,
    fill: "#1c1530"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "80,44 82,58 80,72 78,58",
    fill: "#5ab4ac",
    opacity: 0.75
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "64,60 78,58 96,60 78,62",
    fill: "#5ab4ac",
    opacity: 0.75
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 5,
    fill: "#2a1840"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 4,
    fill: "#c09840",
    opacity: 0.9
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 60,
    r: 2,
    fill: "#f0e0c8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 31,
    width: 5,
    height: 5,
    fill: "#c09840",
    opacity: 0.5,
    transform: "rotate(45 80 33.5)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 86,
    width: 5,
    height: 5,
    fill: "#c09840",
    opacity: 0.5,
    transform: "rotate(45 80 88.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalk3);
export default __webpack_public_path__ + "static/media/talk3.5964bf28c95d6e445bffce1ac3acd432.svg";
export { ForwardRef as ReactComponent };